import PDFViewerSDK from './PDFViewerSDK'

const usePDFViewer = () => {
	return new PDFViewerSDK()
}
export default usePDFViewer
